import { pullTypeMap, forcePull, getLaunchAppCommonParams, pullEventTypeMap, setLaunchAppEnv, formatInvokeAppConfig } from './utils';
import { getBranch } from '../initSDK';
import { getURL } from '../query';
import { getLaunchAppConfig } from '../webx';
import showLaunchAppUi from './ui/launch-app-ui';
import showPassphraseView from './ui/passphrase-ui';
import showGuideView from './ui/user-guide-ui';
// 拉端方法
// eslint-disable-next-line no-async-promise-executor
export const launchApp = (launchAppConfig = {}) => new Promise(async (resolve, reject) => {
    const { extra, hadInvokeApp } = launchAppConfig;
    const invokeAppInfoParams = formatInvokeAppConfig(launchAppConfig);
    getInvokeAppInfo(invokeAppInfoParams).then(res => {
        const launchAppRes = res?.conf || {};
        const { pullType, mainDeepLinks, browser, pullFailDeepLinks } = launchAppRes;
        switch (pullType) {
            // 拉起类型为无动作，表示页面自定义手动拉端，此时不作任何操作
            case pullTypeMap.NO_ACTION:
                resolve(launchAppRes);
                return;
            // 阻断强制拉起，发起拉端动作后，展示等待拉端结果半弹窗
            case pullTypeMap.FORCE_PULL: {
                const mainDeepLink = mainDeepLinks[0];
                const { linkType, link } = mainDeepLink;
                // 该部分逻辑是为了做AB实验而临时添加的，后面去掉，linkType为6代表拉端口令
                if (linkType === 6) {
                    showPassphraseView(link);
                    resolve(launchAppRes);
                }
                else {
                    showLaunchAppUi(launchAppRes, launchAppConfig)
                        .then(() => resolve(launchAppRes))
                        .catch(() => reject(launchAppRes));
                    // 如果主拉端方式是universal link，并且后补拉端有download，跳转时带上口令
                    if (mainDeepLink.linkType === 1) {
                        const iosDownloadLink = pullFailDeepLinks.filter(linkObj => linkObj.linkType === 4)[0] || {};
                        const cmd = iosDownloadLink.cmd || '';
                        mainDeepLink.cmd = cmd;
                    }
                    !hadInvokeApp && forcePull(mainDeepLink, browser, extra);
                }
                break;
            }
            // 引导拉起，让用户点击手机右上角菜单项，选择在浏览器内打开页面
            case pullTypeMap.GUIDE_PULL: {
                showGuideView();
                resolve(launchAppRes);
                break;
            }
            case pullTypeMap.PASSPHRASE: {
                const link = mainDeepLinks[0].link;
                showPassphraseView(link);
                resolve(launchAppRes);
                break;
            }
            default:
                reject(launchAppRes);
        }
    }).catch(err => {
        console.log('err', err);
        reject(err);
    });
});
let invokeAppInfo = {};
export const getInvokeAppInfo = (invokeAppInfoParams) => {
    return new Promise((resolve, reject) => {
        const { env, launchAppDchn, phone, invokeMode, invokePriority, keyboardToken, morePriority, isUseWeixinTag, isCopyCmd, cmdParams } = invokeAppInfoParams;
        setLaunchAppEnv(env);
        const params = {
            args: {
                biz: getBranch(),
                url: getURL(),
                pull_event_type: pullEventTypeMap.BTN_CLICK,
                dchn: launchAppDchn,
                phone,
                invoke_mode: invokeMode || 'click',
                invoke_priority: invokePriority,
                uid_web: window.localStorage.getItem('uid_web') || '',
                keyboard_token: keyboardToken,
                more_priority: morePriority || [],
                is_use_weixin_tag: isUseWeixinTag || false,
                is_copy_cmd: isCopyCmd || false,
                params: cmdParams || {}
            },
            ...getLaunchAppCommonParams()
        };
        const key = JSON.stringify({ ...params, env });
        if (invokeAppInfo[key]) {
            resolve(invokeAppInfo[key]);
            return;
        }
        getLaunchAppConfig(params, env || 'online').then(res => {
            invokeAppInfo[key] = res;
            resolve(res);
        }).catch(reject);
    });
};
